import React from 'react'
import styles from './CustomTextArea.module.scss'
import { Form, Input } from 'antd'
import { useTranslation } from 'next-i18next'

interface CustomTextAreaProps {
  name: string,
  required?: boolean,
  placeholder?: string,
  rows?: number
}

const CustomTextArea: React.FC<CustomTextAreaProps> = (props) => {
  const { name, required = false, placeholder, rows = 3 } = props

  const { t } = useTranslation()

  return (
    <>
      <Form.Item
        name={name}
        rules={[{ required, message: t('general.RequiredValidation'), whitespace: true }]}
      >
        <Input.TextArea
          placeholder={placeholder}
          size='large'
          rows={rows}
          className={styles['custom-text-area']}
        />
      </Form.Item>
    </>
  )
}

export default CustomTextArea
